import type { LevelTwoProgressItem } from '@lemonade-hq/uniclient-chat';
import { Flex } from '@lemonade-hq/uniclient-theme';
import { motion } from 'motion/react';
import { forwardRef } from 'react';
import { progressSubItemsWrapperVariants } from '../animations';
import { LEVEL_TWO_GAP } from '../constants';
import type { AnimationProgressProps } from '../types';
import { ProgressSubItem } from './ProgressSubItem';

interface ProgressSubItemsWrapperProps extends Pick<AnimationProgressProps, 'isBackwards'> {
  readonly items: LevelTwoProgressItem[];
  readonly currentSubItemIndex: NonNullable<AnimationProgressProps['currentSubItemIndex']>;
  readonly currentSubSubItemIndex: NonNullable<AnimationProgressProps['currentSubSubItemIndex']>;
  readonly isFirstRender: boolean;
}

export const ProgressSubItemsWrapper = forwardRef<HTMLDivElement, ProgressSubItemsWrapperProps>(
  ({ items, currentSubItemIndex, currentSubSubItemIndex, isFirstRender, isBackwards }, _) => (
    <Flex
      {...progressSubItemsWrapperVariants}
      as={motion.div}
      flexDirection="column"
      gap={LEVEL_TWO_GAP}
      position="relative"
      right="23px"
      width="100%"
    >
      {items.map((subItem, index) => (
        <ProgressSubItem
          completed={index < currentSubItemIndex}
          current={index === currentSubItemIndex}
          currentSubSubItemIndex={currentSubSubItemIndex}
          isBackwards={isBackwards}
          isFirst={index === 0}
          isFirstRender={isFirstRender}
          item={subItem}
          key={subItem.id}
          previousSubItemHasSubSubItems={items[index - 1]?.subItems != null}
          subItems={subItem.subItems}
        />
      ))}
    </Flex>
  ),
);
